<template>
    <div class="pl-3 pr-3">
        <div class="container pb-4">
            <div class="row pb-3">
                <div class="col-12 col-lg-7">
                    <div class="row">
                        <div class="col-12" :class="{ 'col-lg-10': !$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED }">
                            <h6 class="font-weight-bold">Booking details</h6>
                            <hr class="d-block summary-title-separator mb-4" align="left">
                            <booking-summary-section-one :classes="shouldClasses" :expiryDate="expiryDate" />
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12">
                            <booking-summary-section-four />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-5 mt-2 mt-lg-0">
                    <div
                        class="d-flex justify-content-end align-items-center mt-4"
                        v-if="
                            bookingCompletedDetails &&
                            bookingCompletedDetails.bookings &&
                            Array.isArray(bookingCompletedDetails.bookings) &&
                            bookingCompletedDetails.bookings.length > 0
                        ">
                        <div
                            v-for="booking in bookingCompletedDetails.bookings"
                            class="my-2 text-center col-12 col-lg-10"
                            :key="booking.CRN" v-html="booking.qrcode"></div>
                    </div>
                    <template v-if="$store.getters.GET_ACTIVE_SERVICE_SETTING && (isPaidSingleService || isPaidMultiService)">
                        <div class="row justify-content-end">
                            <div class="col-12 col-lg-10">
                                <booking-summary-section-two :classes="['summary--section--gray']" />
                            </div>
                        </div>
                        <div class="row justify-content-end">
                            <div class="col-12 col-lg-10">
                                <booking-summary-section-three :classes="['summary--section--gray']" />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BookingSummarySectionOne from './BookingSummarySectionOne';
    import BookingSummarySectionTwo from './BookingSummarySectionTwo';
    import BookingSummarySectionThree from './BookingSummarySectionThree';
    import BookingSummarySectionFour from './BookingSummarySectionFour';
    import Helper from '../../../../helper'

    export default {
        props: {
            hasPaidMultiServiceProducts: Boolean
        },
        components: {
            BookingSummarySectionOne,
            BookingSummarySectionTwo,
            BookingSummarySectionThree,
            BookingSummarySectionFour
        },
        data() {
            return {
                Paid: Helper.Payment.Paid,
                expiryDate: ''
            }
        },
        computed: {
            isPaidSingleService() {
                return !this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.$store.getters.GET_ACTIVE_SERVICE_SETTING.is_paid == this.Paid;
            },
            isPaidMultiService() {
                return this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.hasPaidMultiServiceProducts;
            },
            shouldClasses() {
                return this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED;
            },
            bookingCompletedDetails() {
                return this.$store.getters.GET_BOOKING_COMPLETED_DETAILS;
            },
        },
        watch: {
            bookingCompletedDetails: function(data) {
                this.expiryDate = '';
                if(data && data.bookings && Array.isArray(data.bookings)) {
                    data.bookings.forEach(booking => {
                        if(booking.expiryDate) {
                            this.expiryDate = booking.expiryDate;
                        }
                    });
                }
            }
        }
    }
</script>